// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"53b1f3da","453":"dbb0167c","806":"8556a293"}[chunkId] + ".chunk.js";
};